import { useToast } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import api from 'services/api/api';
import { queryClient } from 'services/queryClient/queryClient';
import { AsyncJobProcessTypeEnum } from 'types/asyncExport.types';

import { ProcessType } from '../types/recalculateRestricted.dto';

export const useVerifyJobIsPending = (
	cycleId: number,
	jobPendingSaved: boolean | undefined,
	processType: ProcessType
) => {
	const toast = useToast();
	return useQuery({
		queryKey: ['verify-job-is-pending', +cycleId],
		queryFn: async () => {
			const { data }: AxiosResponse<{ has_ongoing: boolean }> =
				await api.post('async-jobs/check-ongoing', {
					cycle_id: +cycleId,
					process_type:
						AsyncJobProcessTypeEnum.GENERATE_RESTRICTED_PLAN,
				});
			if (!data.has_ongoing && jobPendingSaved !== undefined) {
				queryClient.invalidateQueries({
					queryKey: ['restrictedPlan-list'],
				});
				queryClient.invalidateQueries({
					queryKey: ['restrictedPlan-exists-byId', +cycleId],
				});
				toast({
					title: `Plano restrito ${
						processType === ProcessType.RECALCULATE_RESTRICTED_PLAN
							? 'recalculado'
							: 'gerado'
					} com sucesso!`,
					position: 'bottom-left',
					status: 'success',
					duration: 8000,
					isClosable: true,
				});
			}
			return {
				hasOngoing: data.has_ongoing,
				time: new Date().toISOString(),
			};
		},
		refetchInterval: 5000,
		refetchIntervalInBackground: true,
		enabled: jobPendingSaved,
		_defaulted: false,
	});
};
